import { useTranslation } from 'react-i18next';
import { ExerciseCard } from '@fluent/ui';
import type { GrammarTip as GrammarTipExercise } from '@fluent/types';
import { GrammarVideo } from './GrammarVideo.js';
import './GrammarTip.css';

export interface GrammarTipProps {
  exercise: GrammarTipExercise;
  locked: boolean;
}

/**
 * GrammarTip — a short, no-fail card that explains the skill's grammar point
 * in Georgian before the learner practices it. Placed as the first card of a
 * skill's first lesson. Same engine semantics as PhraseIntro/Dialogue: no
 * test, the SubmitBar "გავიგე" CTA advances. (Added 2026-06-14.) A tip with a
 * `video_key` shows a ▶ button under its title (2026-10-08).
 */
export function GrammarTip({ exercise, locked }: GrammarTipProps) {
  const { t } = useTranslation();
  return (
    <ExerciseCard kicker={t('lesson.grammar_tip.kicker')}>
      <div className="fluent-grammartip" aria-disabled={locked || undefined}>
        <div className="fluent-grammartip__badge" aria-hidden="true">💡</div>
        {exercise.title_ka && (
          <p className="fluent-grammartip__title" lang="ka">
            {exercise.title_ka}
          </p>
        )}
        {exercise.video_key && <GrammarVideo videoKey={exercise.video_key} title={exercise.title_ka} />}
        <p className="fluent-grammartip__body" lang="ka">
          {exercise.ka}
        </p>
      </div>
    </ExerciseCard>
  );
}
